import { Component, OnInit  } from '@angular/core';
import { NgxLightRaysComponent } from "@omnedia/ngx-light-rays";

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [NgxLightRaysComponent],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.css'
})
export class LoadingComponent implements OnInit {

  ngOnInit(): void {
    console.log('--------------------------------');
    console.log('Loading Component');
    console.log('--------------------------------');
  }
}
